import { combineReducers } from 'redux';
import general from './generalTreatmentInstancesReducer';
import previewedRescheduledInformation from './previewedRescheduledInformationReducer';
import postcodeDistance from './mileageCapReducer';

const treatmentInstances = combineReducers({
  general,
  previewedRescheduledInformation,
  postcodeDistance,
});

export default treatmentInstances;
